import React from 'react';
import UmlConnectorAnchorHandle from './UmlConnectorAnchorHandle.jsx';

/**
 * Renders the start/end anchor handles for a single connector. The parent
 * renders these after waypoints/line so they win pointer-event priority over
 * the line's hit-area at the endpoints.
 * @param {object} props
 * @param {object} props.connector - connector data
 * @param {Array<{x:number,y:number}>} props.points - resolved path points (first/last used as anchors)
 * @param {Function} props.onAnchorDragStart - fn(connector, variant, event) — start reattach/drag
 */
function UmlConnectorEndpoints({ connector, points, onAnchorDragStart }) {
    const size = 14;
    const start = points[0];
    const end = points[points.length - 1];
    return (
        <>
            <foreignObject
                x={start.x - size / 2}
                y={start.y - size / 2}
                width={size}
                height={size}
                data-connector-id={connector.id}
                data-geo-label="Anchor (start)"
                data-geo-x={start.x}
                data-geo-y={start.y}
            >
                <UmlConnectorAnchorHandle
                    variant="start"
                    connector={connector}
                    onReattachDragStart={function startReattach(variant, e) {
                        onAnchorDragStart?.(connector, variant, e);
                    }}
                />
            </foreignObject>

            <foreignObject
                x={end.x - size / 2}
                y={end.y - size / 2}
                width={size}
                height={size}
                data-connector-id={connector.id}
                data-geo-label="Anchor (end)"
                data-geo-x={end.x}
                data-geo-y={end.y}
            >
                <UmlConnectorAnchorHandle
                    variant="end"
                    connector={connector}
                    onReattachDragStart={function startReattach(variant, e) {
                        onAnchorDragStart?.(connector, variant, e);
                    }}
                />
            </foreignObject>
        </>
    );
}

export default UmlConnectorEndpoints;
